var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.04,0 H -1.13672 V 4252 H 4253.04 V 0",
    style: {
      fill: "#f6911a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 303.688,3739.81 v -150.52 h 1.238 l 101.203,105.03 h 1.289 v -656.63 h 144.215 v 857.79 H 436.488 l -132.8,-155.67",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 632.594,3739.81 v -150.52 h 1.289 l 101.207,105.03 h 1.234 V 3037.69 H 880.59 v 857.79 H 765.504 l -132.91,-155.67",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1219.86,3771.83 v -225.76 h -50.87 v 359.31 h 59.35 l 65.19,-206.15 v 206.15 h 50.34 v -359.31 h -53 l -71.01,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1441.93,3660.01 h 48.22 l -23.85,144.14 h -0.52 z m -75.78,-113.94 67.83,359.31 h 68.89 l 68.36,-359.31 h -62 l -11.13,65.72 h -64.12 l -10.6,-65.72 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1585.56,3638.81 v 173.82 c 0,56.18 26.5,96.98 90.09,96.98 66.78,0 85.32,-37.1 85.32,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.42,34.98 -29.15,34.98 -21.72,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.97 v 66.25 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1909.9,3704.52 h -58.29 v -158.45 h -60.41 v 359.31 h 60.41 v -152.1 h 58.29 v 152.1 h 60.94 v -359.31 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2121.37,3704.52 h -58.29 v -158.45 h -60.41 v 359.31 h 60.41 v -152.1 h 58.29 v 152.1 h 60.94 v -359.31 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2280.38,3660.01 h 48.22 l -23.85,144.14 h -0.53 z m -75.79,-113.94 67.84,359.31 h 68.89 l 68.36,-359.31 h -62 l -11.13,65.72 h -64.12 l -10.6,-65.72 h -57.24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2431.96,3905.38 h 60.41 v -310.02 h 72.07 v -49.29 h -132.48 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2548.03,3905.38 h 160.57 v -49.29 h -49.82 v -310.02 h -60.94 v 310.02 h -49.81 v 49.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2734.05,3905.38 h 60.42 v -359.31 h -60.42 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2917.95,3737.91 h 85.85 v -191.84 h -43.46 v 39.22 c -7.95,-27.02 -24.91,-43.45 -57.76,-43.45 -51.94,0 -75.78,41.33 -75.78,96.97 v 173.82 c 0,56.18 27.02,96.98 90.62,96.98 66.77,0 86.38,-37.1 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.6,0 29.67,11.12 29.67,34.45 v 63.59 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3035.61,3905.38 h 144.15 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 h -144.15 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1165.81,3123.45 v 48.22 h 56.17 v -49.29 c 0,-20.13 9.01,-31.79 29.68,-31.79 19.08,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.11 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1353.43,3405.38 H 1514 v -49.29 h -49.82 v -310.01 h -60.94 v 310.01 h -49.81 v 49.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1612.06,3463.66 h 51.4 v -45.57 h -51.4 z m -32.86,-303.65 h 48.23 l -23.85,144.14 h -0.53 z m -31.27,303.65 h 51.41 v -45.57 h -51.41 z m -44.51,-417.58 67.83,359.3 h 68.9 l 68.36,-359.3 h -62.01 l -11.12,65.71 h -64.13 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1816.63,3095.35 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.43 v -260.74 z m 94.86,213.58 v -166.41 c 0,-55.12 -22.78,-96.44 -87.44,-96.44 h -93.27 v 359.3 h 93.27 c 64.66,0 87.44,-40.82 87.44,-96.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1928.47,3405.38 h 160.57 v -49.29 h -49.81 v -310.01 h -60.94 v 310.01 h -49.82 v 49.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2114.49,3405.38 h 144.15 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.15 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2516.74,3405.38 v -271.86 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.86 h 60.41 v -277.69 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.2,0 29.67,14.31 29.67,35.51 v 277.69 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2599.43,3271.83 v -225.75 h -50.87 v 359.3 h 59.36 l 65.18,-206.15 v 206.15 h 50.34 v -359.3 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2841.1,3095.35 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.43 v -260.74 z m 94.86,213.58 v -166.41 c 0,-55.12 -22.78,-96.44 -87.43,-96.44 h -93.28 v 359.3 h 93.28 c 64.65,0 87.43,-40.82 87.43,-96.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1260.14,2737.91 h 85.85 v -191.83 h -43.46 v 39.21 c -7.95,-27.03 -24.9,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.97 v 173.82 c 0,56.18 27.03,96.98 90.62,96.98 66.77,0 86.38,-37.1 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.25 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.61,0 29.67,11.12 29.67,34.44 v 63.6 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1377.8,2905.37 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 H 1377.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1718.04,2779.25 h -1.58 l -40.81,-233.17 h -28.09 l -45.05,233.17 h -1.05 v -233.17 h -49.82 v 359.29 h 70.48 l 39.22,-202.44 h 0.53 l 34.98,202.44 h 76.3 v -359.29 h -55.11 v 233.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1804.97,2905.37 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1978.81,2905.37 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2122.43,2771.83 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2364.1,2595.35 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.43 v -260.74 z m 94.86,213.58 v -166.41 c 0,-55.12 -22.78,-96.44 -87.44,-96.44 h -93.27 v 359.29 h 93.27 c 64.66,0 87.44,-40.81 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2490.78,2905.37 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2715.49,2771.83 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 941.055,915.141 h 531.995 c 7.19,0 13.05,5.879 13.05,13.078 0,3.351 -1.35,6.363 -3.43,8.679 l -0.73,0.774 -264.68,342.458 -2.58,2.83 c -2.4,2.62 -5.81,4.25 -9.64,4.25 -3.28,0 -6.22,-1.37 -8.56,-3.35 l -1.59,-1.85 -2.48,-2.78 -258.226,-338.859 -3.969,-4.84 c -1.414,-2.07 -2.231,-4.601 -2.231,-7.312 0,-7.199 5.86,-13.078 13.071,-13.078",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1471.44,866.852 H 938.395 c -7.211,0 -13.051,-5.84 -13.051,-13.063 V 436.641 c 0,-7.2 5.84,-13.09 13.051,-13.09 H 1109.97 V 686 c 0,7.25 5.81,13.039 13.04,13.039 h 159.26 c 7.21,0 13.05,-5.789 13.05,-13.039 V 423.551 h 176.12 c 7.19,0 13.05,5.89 13.05,13.09 v 417.148 c 0,7.223 -5.86,13.063 -13.05,13.063",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3265.96,805.289 c 0,-6.957 -5.75,-12.578 -12.92,-12.578 h -157.58 c -7.17,0 -12.92,5.621 -12.92,12.578 v 95.852 c 0,6.91 5.75,12.531 12.92,12.531 h 157.58 c 7.17,0 12.92,-5.621 12.92,-12.531 z m 0,-177.027 c 0,-7 -5.75,-12.614 -12.92,-12.614 h -157.58 c -7.17,0 -12.92,5.614 -12.92,12.614 v 95.769 c 0,7 5.75,12.571 12.92,12.571 h 157.58 c 7.17,0 12.92,-5.571 12.92,-12.571 z m -240.9,177.027 c 0,-6.957 -5.75,-12.578 -12.88,-12.578 h -157.61 c -7.18,0 -12.97,5.621 -12.97,12.578 v 95.852 c 0,6.91 5.79,12.531 12.97,12.531 h 157.61 c 7.13,0 12.88,-5.621 12.88,-12.531 z m 0,-177.027 c 0,-7 -5.75,-12.614 -12.88,-12.614 h -157.61 c -7.18,0 -12.97,5.614 -12.97,12.614 v 95.769 c 0,7 5.79,12.571 12.97,12.571 h 157.61 c 7.13,0 12.88,-5.571 12.88,-12.571 z m 288.68,347.789 h -527.6 c -7.13,0 -12.88,-5.539 -12.88,-12.539 v -532.75 c 0,-6.91 5.75,-12.543 12.88,-12.543 h 527.6 c 7.16,0 12.92,5.633 12.92,12.543 v 532.75 c 0,7 -5.76,12.539 -12.92,12.539",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2012.02,1834.04 c 0,-3.7 -3.05,-6.74 -6.82,-6.74 h -118.18 c -3.77,0 -6.78,3.04 -6.78,6.74 v 131.78 c 0,3.78 3.01,6.78 6.78,6.78 h 118.18 c 3.77,0 6.82,-3 6.82,-6.78 z m 0,-302.5 c 0,-3.74 -3.05,-6.78 -6.82,-6.78 h -118.18 c -3.77,0 -6.78,3.04 -6.78,6.78 v 131.78 c 0,3.74 3.01,6.7 6.78,6.7 h 118.18 c 3.77,0 6.82,-2.96 6.82,-6.7 z m 0,-302.58 c 0,-3.73 -3.05,-6.78 -6.82,-6.78 h -118.18 c -3.77,0 -6.78,3.05 -6.78,6.78 v 131.78 c 0,3.73 3.01,6.78 6.78,6.78 h 118.18 c 3.77,0 6.82,-3.05 6.82,-6.78 z m 0,-302.491 c 0,-3.821 -3.05,-6.778 -6.82,-6.778 h -118.18 c -3.77,0 -6.78,2.957 -6.78,6.778 v 131.691 c 0,3.82 3.01,6.78 6.78,6.78 h 118.18 c 3.77,0 6.82,-2.96 6.82,-6.78 z m 0,-302.578 c 0,-3.743 -3.05,-6.789 -6.82,-6.789 h -118.18 c -3.77,0 -6.78,3.046 -6.78,6.789 v 131.738 c 0,3.73 3.01,6.742 6.78,6.742 h 118.18 c 3.77,0 6.82,-3.012 6.82,-6.742 z M 1780.18,1834.04 c 0,-3.7 -3.05,-6.74 -6.78,-6.74 h -118.22 c -3.73,0 -6.78,3.04 -6.78,6.74 v 131.78 c 0,3.78 3.05,6.78 6.78,6.78 h 118.22 c 3.73,0 6.78,-3 6.78,-6.78 z m 0,-302.5 c 0,-3.74 -3.05,-6.78 -6.78,-6.78 h -118.22 c -3.73,0 -6.78,3.04 -6.78,6.78 v 131.78 c 0,3.74 3.05,6.7 6.78,6.7 h 118.22 c 3.73,0 6.78,-2.96 6.78,-6.7 z m 0,-302.58 c 0,-3.73 -3.05,-6.78 -6.78,-6.78 h -118.22 c -3.73,0 -6.78,3.05 -6.78,6.78 v 131.78 c 0,3.73 3.05,6.78 6.78,6.78 h 118.22 c 3.73,0 6.78,-3.05 6.78,-6.78 z m 0,-302.491 c 0,-3.821 -3.05,-6.778 -6.78,-6.778 h -118.22 c -3.73,0 -6.78,2.957 -6.78,6.778 v 131.691 c 0,3.82 3.05,6.78 6.78,6.78 h 118.22 c 3.73,0 6.78,-2.96 6.78,-6.78 z m 0,-302.578 c 0,-3.743 -3.05,-6.789 -6.78,-6.789 h -118.22 c -3.73,0 -6.78,3.046 -6.78,6.789 v 131.738 c 0,3.73 3.05,6.742 6.78,6.742 h 118.22 c 3.73,0 6.78,-3.012 6.78,-6.742 z m 307.13,1588.769 h -516.3 c -6.91,0 -12.63,-5.63 -12.63,-12.66 V 435.48 c 0,-6.949 5.72,-12.621 12.63,-12.621 h 516.3 c 6.91,0 12.71,5.672 12.71,12.621 V 2200 c 0,7.03 -5.8,12.66 -12.71,12.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3326.05,1029.66 c 0,-5.93 -4.72,-10.64 -10.6,-10.64 h -531.03 c -5.84,0 -10.6,4.71 -10.6,10.64 v 106.2 c 0,5.83 4.76,10.6 10.6,10.6 h 531.03 c 5.88,0 10.6,-4.77 10.6,-10.6 v -106.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2652.26,1340.31 c 0,-7 -5.71,-12.62 -12.63,-12.62 h -153.84 c -7.04,0 -12.7,5.62 -12.7,12.62 v 96.32 c 0,7.04 5.66,12.67 12.7,12.67 h 153.84 c 6.92,0 12.63,-5.63 12.63,-12.67 z m 0,-178.01 c 0,-6.96 -5.71,-12.58 -12.63,-12.58 h -153.84 c -7.04,0 -12.7,5.62 -12.7,12.58 v 96.33 c 0,6.99 5.66,12.61 12.7,12.61 h 153.84 c 6.92,0 12.63,-5.62 12.63,-12.61 z m 0,-178.011 c 0,-6.91 -5.71,-12.578 -12.63,-12.578 h -153.84 c -7.04,0 -12.7,5.668 -12.7,12.578 v 96.371 c 0,6.99 5.66,12.61 12.7,12.61 h 153.84 c 6.92,0 12.63,-5.62 12.63,-12.61 z m 0,-177.969 c 0,-7 -5.71,-12.629 -12.63,-12.629 h -153.84 c -7.04,0 -12.7,5.629 -12.7,12.629 v 96.328 c 0,7.032 5.66,12.622 12.7,12.622 h 153.84 c 6.92,0 12.63,-5.59 12.63,-12.622 z m 0,-177.968 c 0,-7 -5.71,-12.622 -12.63,-12.622 h -153.84 c -7.04,0 -12.7,5.622 -12.7,12.622 v 96.32 c 0,6.957 5.66,12.578 12.7,12.578 h 153.84 c 6.92,0 12.63,-5.621 12.63,-12.578 z m -234.81,745.958 v -212.18 c 0,-7 -5.71,-12.63 -12.62,-12.63 h -153.84 c -7.04,0 -12.71,5.63 -12.71,12.63 v 25.63 1.07 c 0.06,1.67 0.39,3.26 0.97,4.72 0.26,0.51 0.3,0.73 0.77,1.46 0.3,0.6 0.73,1.15 1.12,1.67 0.38,0.61 0.96,1.38 1.44,2.06 19.66,28.17 108.43,137.49 145.71,183.21 l 3.73,4.51 c 2.7,3.26 6.78,5.36 11.35,5.36 7.06,0 12.71,-5.15 14.08,-11.8 z m -0.42,-390.021 c 0,-6.91 -5.63,-12.578 -12.63,-12.578 h -153.88 c -7,0 -12.62,5.668 -12.62,12.578 v 96.371 c 0,6.99 5.62,12.61 12.62,12.61 h 153.88 c 7,0 12.63,-5.62 12.63,-12.61 z m 0,-177.969 c 0,-7 -5.63,-12.629 -12.63,-12.629 h -153.88 c -7,0 -12.62,5.629 -12.62,12.629 v 96.328 c 0,7.032 5.62,12.622 12.62,12.622 h 153.88 c 7,0 12.63,-5.59 12.63,-12.622 z m 0,-177.968 c 0,-7 -5.63,-12.622 -12.63,-12.622 h -153.88 c -7,0 -12.62,5.622 -12.62,12.622 v 96.32 c 0,6.957 5.62,12.578 12.62,12.578 h 153.88 c 7,0 12.63,-5.621 12.63,-12.578 z m 80.28,901.518 3.63,4.56 c 34.73,44.55 93.23,116.58 121.76,151.56 l 3.74,4.46 c 2.7,3.26 6.78,5.37 11.35,5.37 7.06,0 12.7,-5.11 14.08,-11.8 v -5.72 -4.63 -152.52 c 0,-7.85 -6.24,-14.16 -14.02,-14.51 -0.23,0 -0.42,-0.12 -0.64,-0.12 -0.22,0 -0.41,0.12 -0.64,0.12 h -120.52 -6.28 c -0.24,0 -0.43,-0.12 -0.65,-0.12 -0.21,0 -0.41,0.12 -0.64,0.12 -7.77,0.35 -14.02,6.66 -14.02,14.51 0,3.27 1.05,6.27 2.85,8.72 z m 213.65,349.59 c -1.72,5.66 -6.75,9.87 -12.97,9.87 -2.78,0 -5.21,-1.04 -7.38,-2.45 -0.32,-0.22 -0.64,-0.38 -0.97,-0.65 l -4.35,-5.49 -507.45,-643.71 -2.34,-3.13 c -2.61,-2.58 -4.29,-6.1 -4.4,-10.05 v -0.86 -790.17 c 0,-6.949 5.67,-12.57 12.67,-12.57 h 515.79 c 7,0 12.62,5.621 12.62,12.57 v 1441.35 c 0,1.9 -0.5,3.69 -1.22,5.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe11);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-11.37da5be8c1fb69b9b27be116edc38d81.svg";
export { ForwardRef as ReactComponent };